import Tables from 'src/class/Tables';
import i18n from 'src/i18n';

const configTable = () => {
  const Table = { ...Tables.Table };
  Table.tableColumns = [
    {
      prop: 'date_save',
      label: i18n.t('common_words.date'),
      minWidth: 150,
    },
    {
      prop: 'name',
      label: i18n.t('common_words.farm'),
      minWidth: 150,
    },
    {
      prop: 'engine',
      label: i18n.t('irrigation.engine'),
      minWidth: 150,
    },
    {
      prop: 'lamina',
      label: i18n.t('irrigation.plate_apply_unit'),
      minWidth: 150,
    },
    {
      prop: 'lamina_aplicada',
      label: i18n.t('irrigation.plate_applied_unit'),
      minWidth: 150,
    },
    {
      prop: 'cumplimiento_lamina',
      label: i18n.t('irrigation.plate_compliance_percentage'),
      minWidth: 150,
    },
    {
      prop: 'tiempo_regar',
      label: i18n.t('irrigation.irrigation_total_apply_time_unit'),
      minWidth: 150,
    },
    {
      prop: 'hourmeter',
      label: i18n.t('irrigation.total_applied_time_unit'),
      minWidth: 150,
    },
    {
      prop: 'cumplimiento_tiempo',
      label: i18n.t('irrigation.time_compliance_percentage'),
      minWidth: 150,
    },
    {
      prop: 'volumen_regar',
      label: i18n.t('irrigation.volume_total_apply'),
      minWidth: 150,
    },
    {
      prop: 'hydrometer',
      label: i18n.t('irrigation.volume_total_applied'),
      minWidth: 150,
    },
    {
      prop: 'cumplimiento_riego',
      label: i18n.t('irrigation.volume_compliance_percentage'),
      minWidth: 150,
    },
    {
      prop: 'precipitacion',
      label: i18n.t('climate.rain'),
      minWidth: 150,
    },
    {
      prop: 'observation',
      label: i18n.t('common_words.observation'),
      minWidth: 150,
    },
  ];

  return { Table };
};

export default configTable;
